module.exports = __webpack_public_path__ + "media/IBMPlexSans-Regular.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/IBMPlexSans/IBMPlexSans-Regular.woff
// module id = 1474
// module chunks = 58